import {action, observable} from "mobx";
import BaseStore from "./base-store";

export default class SimpleStore extends BaseStore {

    @observable
    public isFetching: boolean = false;

    @action
    protected startFetching() {
        this.isFetching = true;
    }

    @action
    protected finishFetching() {
        this.isFetching = false;
    }
}



// WEBPACK FOOTER //
// ./src/stores/base/simple-store.ts